import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_CHARACTER_RANKINGS,
  SET_KEYSTONE_CHARACTER_RANKINGS_ERROR,
  SHOW_KEYSTONE_LOADING_SPINNER
} from '../actions/keystoneActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

const DEFAULT_STATE = {
  instances: {}
};

export default function keystoneCharacterRankings(
  state: Partial<TCharacterDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_KEYSTONE_CHARACTER_RANKINGS: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: action.payload.data
        }
      };
    }
    case SHOW_KEYSTONE_LOADING_SPINNER: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            ...state.instances[action.payload.instanceId],
            isLoading: action.payload.show
          }
        }
      };
    }
    case SET_KEYSTONE_CHARACTER_RANKINGS_ERROR: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: {
            isError: true,
            error: action.payload.error
          }
        }
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
